import { Controller } from "@hotwired/stimulus"
import TomSelect from "tom-select"

export default class extends Controller {
  static values = {
    placeholder: { type: String, default: "選択してください" },
    allowEmpty: { type: Boolean, default: true },
    clearOnInit: { type: Boolean, default: false },
    hideEmptyOption: { type: Boolean, default: false }
  }

  connect() {
    const plugins = this.allowEmptyValue ? ["clear_button"] : []

    this.tomSelect = new TomSelect(this.element, {
      plugins,
      allowEmptyOption: this.allowEmptyValue,
      placeholder: this.placeholderValue,
      controlInput: "<input>",
      render: {
        no_results: () => '<div class="no-results">該当なし</div>'
      }
    })

    // NOTE: 先頭の空 option が自動選択されプレースホルダーが出ない問題を回避するためのオプション
    if (this.clearOnInitValue) {
      this.tomSelect.clear(true)
    }

    // NOTE: 空 option を検索候補（ドロップダウン）から除外する。未選択 = 空送信の扱いは維持される。
    if (this.hideEmptyOptionValue) {
      this.tomSelect.removeOption("")
    }

    // NOTE: HTML5 の required バリデーションメッセージを日本語化する
    if (this.element.hasAttribute("required")) {
      this.element.addEventListener("invalid", this.onInvalid)
      this.element.addEventListener("change", this.onChange)
    }
  }

  disconnect() {
    if (this.element.hasAttribute("required")) {
      this.element.removeEventListener("invalid", this.onInvalid)
      this.element.removeEventListener("change", this.onChange)
    }
    if (this.tomSelect) {
      this.tomSelect.destroy()
    }
  }

  onInvalid = (event) => {
    event.target.setCustomValidity("項目を選択してください")
  }

  onChange = (event) => {
    event.target.setCustomValidity("")
  }
}
